import { graphql } from "../../generated"

export const WELL_FAVORITES_ADD = graphql(`
    mutation WellFavoritesAdd($WellFavoritesAddInput: WellFavoritesAddInput!) {
        wellFavoritesAdd(input: $WellFavoritesAddInput) {
            wellFavorites {
                well {
                    id
                    isFavorite
                }
            }
        }
    }
`)

export const WELL_FAVORITES_DELETE = graphql(`
    mutation WellFavoritesDelete(
        $WellFavoritesDeleteInput: WellFavoritesDeleteInput!
    ) {
        wellFavoritesDelete(input: $WellFavoritesDeleteInput) {
            wells {
                id
                isFavorite
            }
        }
    }
`)
